<template>
  <v-container grid-list-md pa-0>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion" v-html="textSpanish"></p>
        <p class="palabraResaltada primary--text"></p>
        <p class="ejemplo" v-html="textExample"></p>
      </div>
      <div class="e-ejercicio-ejercicio py-3">
        <v-card class="e-elevation--3 radius">
          <v-card-text>
            <h3 class="e-description-big" v-html="textExercise"></h3>
          </v-card-text>
        </v-card>
        <div class="primary--text py-3"><v-icon class="primary--text">arrow_downward</v-icon></div>
        <v-card class="elevation-0 transparent e-ejercicio-ejercicio-empty mb-3">
          <v-card-text style="height: 115px" class="pa-2">
            <draggable class="list-group layout" :list="soluciones" style="height: 100%" group="options"
              @change="updateValue(soluciones)"
            >
              <v-flex
                xs4
                class="list-group-item"
                v-for="(solucion, index) in soluciones"
                :key="`textSol-${index}`">
                <v-card class="e-elevation--3 radius">
                  <v-card-text>
                    <p class="e-description-middle mb-0 text-xs-center py-3">{{ solucion }}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </draggable>
          </v-card-text>
        </v-card>
        <draggable class="list-group layout" :list="options" group="options">
          <v-flex  class="list-group-item" xs4 v-for="(option, index) in options" :key="`textOpt-${index}`">
            <v-card class="e-elevation--3 radius">
              <v-card-text>
                <p class="e-description-middle mb-0 text-xs-center py-3">{{ option }}</p>
              </v-card-text>
            </v-card>
          </v-flex>
        </draggable>
      </div>
    </div>
  </v-container>
</template>
<script>
import draggable from 'vuedraggable'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: 'practicaArrastrar',
  props: {
    textSpanish: {
      type: String,
      default: ''
    },
    textExercise: {
      type: String,
      default: ''
    },
    textExample: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    answer: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      soluciones: []
    }
  },
  components: {
    draggable
  },
  methods: {
    updateValue (soluciones) {
      const respuestaFinal = {
        answer: this.answer,
        userAnswer: soluciones
      }
      this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>
